// extracted by mini-css-extract-plugin
module.exports = {"root":"IconTipsAndUpdates_root__23bC1"};